const style = (color: string) => ({
    color: color,
    textShadow: '0px 1px #DDD',
    fontWeight: 'bolder'
})

export default ({ text, color } : { text: string; color: string }) => {
    return (
        <span style={style(color)}>
            { (text || '')?.toUpperCase() }
        </span>
    )
}